import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import React, { Component, ReactNode } from "react"
import { colors, sizes } from "ui/theme/theme"

const FallbackContainer = styled(Box)`
  padding: ${sizes.baseSingle};
  background-color: ${colors.red};
  color: ${colors.white};
  border-radius: ${sizes.borderRadius};
  margin-top: ${sizes.baseSingle};
`

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Optionally log error to an error reporting service
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("Error in InvestmentGraph:", error, errorInfo)
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <FallbackContainer>
          <Typography variant="caption">
            שגיאה בטעינת הגרף. נסו לרענן את הדף או לחזור מאוחר יותר.
          </Typography>
        </FallbackContainer>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
